<template>
  <div>
    <template v-if="pms">
      <app-title></app-title>
      <!-- <pms-search></pms-search> -->
      <app-table></app-table>
    </template>

    <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";

export default {
  data() {
    return {
      pms: false,
    };
  },
  components: { NoPms },
  mixins: [components, mixin],
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
    history.pushState(null, null, document.URL);
  });

    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["80000"].check;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PartI/AppManage/index.vue